import { action } from "typesafe-actions";
import produce from "immer";
import { LoadState } from "../../../constants/enums";
import { IStoreState } from "../../initialStoreState";
import { CampaignReportsActions } from "./index";
import {
    FETCH_CAMPAIGN_REPORTS_LIST_PROGRESS,
    FETCH_CAMPAIGN_REPORTS_LIST_SUCCESS,
    FETCH_CAMPAIGN_REPORTS_LIST_FAILURE,
    CLEAR_CAMPAIGN_REPORTS_STATE
} from "./CampaignReports.action";
import { InitialCampaignReportsReduxState } from "./CampaignReports.state";

export const campaignReportsReducer = (
    state: IStoreState["campaignReports"] = InitialCampaignReportsReduxState,
    action: CampaignReportsActions
) => {
    switch (action.type) {
        case FETCH_CAMPAIGN_REPORTS_LIST_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.InProgress;
                draftState.list.list = [];
                draftState.list.totalRecords = 0;
            });
            return newState;
        }
        case FETCH_CAMPAIGN_REPORTS_LIST_SUCCESS: {
            const { list, totalRecords } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.Loaded;
                draftState.list.list = list;
                draftState.list.totalRecords = totalRecords;
            });
            return newState;
        }
        case FETCH_CAMPAIGN_REPORTS_LIST_FAILURE: {
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.Failed;
                draftState.list.list = [];
                draftState.list.totalRecords = 0;
            });
            return newState;
        }
        case CLEAR_CAMPAIGN_REPORTS_STATE: {
            return InitialCampaignReportsReduxState;
        }
        default: {
            return state;
        }
    }
}
